// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"537":"ef48ebd3","554":"61d34936","602":"e9a0133c"}[chunkId] + ".chunk.js";
};